import { Injectable, Inject } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SocketService {
    constructor(@Inject('SocketServer') private socket: Socket) {}

    // Escutar eventos
    fromEvent<T>(eventName: string): Observable<T> {
        return this.socket.fromEvent<T>(eventName);
    }

    // Emitir eventos
    emit(eventName: string, data?: any): void {
        this.socket.emit(eventName, data);
    }

    // Verificar se está conectado
    isConnected(): boolean {
        return this.socket.ioSocket.connected;
    }

    // Conectar
    connect(): void {
        this.socket.connect();
    }

    // Desconectar
    disconnect(): void {
        this.socket.disconnect();
    }
}
